import { Stack } from "@mui/material";
import SnackbarContent, {
  SnackbarContentProps,
} from "@mui/material/SnackbarContent";
import React, { forwardRef } from "react";
import { EIconNames } from "../types/iconNames";
import { Note, ENoteVariant } from "./Note";
import { IconButton } from ".";

export type TSnackbarVariant = "success" | "warning" | "error";

export interface ISnackbarComponentProps
  extends Omit<SnackbarContentProps, "action" | "handleClose" | "variant"> {
  variant?: TSnackbarVariant;
  iconName?: EIconNames;
  handleClose?: (key?: string | number) => void;
}

const SnackbarComponent = forwardRef<HTMLDivElement, ISnackbarComponentProps>(
  ({ id, ...props }, ref) => {
    const { handleClose, message, variant, iconName } = props;

    const Actions = () => (
      <Stack direction="row" spacing={2}>
        {!!handleClose && (
          <IconButton
            variant="text"
            color="secondary"
            sx={{ color: "grey.600" }}
            onClick={() => handleClose(id)}
            iconName="close"
          />
        )}
      </Stack>
    );

    return (
      <SnackbarContent
        ref={ref}
        message={
          <Note
            sx={{ whiteSpace: "pre" }}
            message={message}
            iconName={iconName}
            variant={variant as ENoteVariant}
          />
        }
        action={<Actions />}
      />
    );
  },
);

SnackbarComponent.displayName = "SnackbarComponent";

export default SnackbarComponent;
